import { Grid } from '@material-ui/core';
import { MUIDataTableColumn, MUIDataTableMeta } from 'mui-datatables';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CustomDataTable from '../../../../../components/CustomDataTable';
import CustomDialog, {
  CustomDialogProps,
} from '../../../../../components/CustomDialog';
import TableSkeleton from '../../../../../components/TableSkeleton';
import { AppState } from '../../../../../store';
import { PunchCardReducerData } from '../../../../../store/reducers/punchCardReducer';
export interface TodayReferencePunchCardTableData {
  employeeName: string;
  employeeRegisters: string[];
  employeeOffice: string;
}

interface OccurrencesTodayDetailedStatusDialogProps extends CustomDialogProps {
  open: boolean;
  occurrencesTypeSelected: string;
  handleClose: () => void;
}

const OccurrencesTodayDetailedStatusDialog: React.FC<OccurrencesTodayDetailedStatusDialogProps> = ({
  occurrencesTypeSelected,
  title,
  open,
  handleClose,
}) => {
  const [todayPunchCardTableData, setTodayPunchCardTableData] = useState<
    TodayReferencePunchCardTableData[]
  >([]);

  const {
    loadingTodayReferencePunchCard,
    todayReferencePunchCard,
  }: PunchCardReducerData = useSelector(
    (state: AppState) => state.punchCardReducer,
  );
  const columns: MUIDataTableColumn[] = [
    {
      name: 'employeeName',
      label: 'Colaborador',
    },
    {
      name: 'employeeOffice',
      label: 'Cargo',
    },
    {
      name: 'employeeRegisters',
      label: 'Marcações',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (
          value: string[],
          _tableMeta: MUIDataTableMeta,
          _updateValue: any,
        ) => value?.join(' - '),
      },
    },
  ];

  useEffect(() => {
    const arr: TodayReferencePunchCardTableData[] = [];
    todayReferencePunchCard
      .filter(
        punchCard => punchCard.pontos[0]?.statusDia === occurrencesTypeSelected,
      )
      .forEach(punchCard => {
        arr.push({
          employeeName: punchCard.funcionario?.nome,
          employeeOffice: punchCard.funcionario?.cargo?.descricao,
          employeeRegisters: punchCard.pontos[0]?.horarios,
        });
      });

    setTodayPunchCardTableData(arr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [todayReferencePunchCard, occurrencesTypeSelected]);

  return (
    <CustomDialog
      maxWidth="lg"
      handleClose={handleClose}
      showCloseButton
      showOneButton
      title={title}
      contentDividers
      open={open}
    >
      <Grid container direction="column" justify="space-between">
        <Grid item xs={12}>
          {loadingTodayReferencePunchCard ? (
            <TableSkeleton rows={4} />
          ) : (
            <CustomDataTable
              data={todayPunchCardTableData.sort((a, b) =>
                a.employeeName > b.employeeName ? 1 : -1,
              )}
              columns={columns}
              options={{
                elevation: 0,
              }}
              title=""
            />
          )}
        </Grid>
      </Grid>
    </CustomDialog>
  );
};

export default OccurrencesTodayDetailedStatusDialog;
